import { TableBody } from 'components/Table/TableBody/TableBody';
import { queryKeys } from 'utils/query';
import { Center, Mark, Stack } from '@mantine/core';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';
import { BsDisplay, BsPlus } from 'react-icons/bs';
import { PortalButton } from 'components/Button/PortalButton';
import { Trans, useTranslation } from 'react-i18next';
import { RulesColumns } from 'components/Table/Columns/RulesColumns';
import { RuleItem } from 'models/rules';
import { useDrawerContext } from 'context/hooks';
import { useParams } from 'react-router-dom';
import { usePatient } from 'hooks/api/useUser';
import { RuleDrawer } from 'components/Drawer/RuleDrawer/RuleDrawer';
import { getPatientRulesRecords } from 'hooks/api/rule/useGetRules';
import { PatientDetailsTitle } from '../PatientDetailsTitle';

export const PatientRulesList = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patientData } = usePatient({ patientId });

  const activeGroups = patientData?.visibleEnlistments || [];

  return (
    <Stack>
      <PatientDetailsTitle title={t('monitoring_rules_title')} Icon={BsDisplay} />
      {Object.values(activeGroups).map((enlistment) => {
        return (
          <TableBody<RuleItem>
            key={enlistment.groupId}
            getData={getPatientRulesRecords}
            getColumns={() => RulesColumns({ showTypeColumn: true })}
            config={{
              queryKey: `${queryKeys.patientRules}-${patientId}-${enlistment.groupId}`,
              groupId: enlistment.groupId,
            }}
            titleBar={
              <PaperHeader titleKey={enlistment.name}>
                <PortalButton
                  size={'xs'}
                  Icon={BsPlus}
                  variant={'outline'}
                  onClick={() =>
                    patientId &&
                    openDrawer({
                      content: <RuleDrawer createItem={{ patientId, groupId: enlistment.groupId }} />,
                      size: '70%',
                      title: (
                        <Trans
                          i18nKey={'individual_rule_title'}
                          components={{
                            mark: <Mark key={'markKey'} color={'white'} c={'var(--mantine-color-blue-5)'} />,
                          }}
                          values={{
                            patient: `${patientData?.lastName} ${patientData?.firstName}`,
                            group: enlistment.name,
                          }}
                        />
                      ),
                    })
                  }
                  label={t('add_rule_label')}
                />
              </PaperHeader>
            }
            emptyLabel={'no_rules_label'}
          />
        );
      })}
      {activeGroups.length < 1 && <Center>{t('no_groups_label')}</Center>}
    </Stack>
  );
};
